export default __webpack_public_path__ + "static/media/R7SR105.626fa8ce.png";